<h1 class="title">
  <span class="main-menu-header-text"><%= I18n.header.title %></span>
  <span class="main-menu-expander-container"></span>
</h1>
<div class="main-menu-container"></div>
